import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { withCookies } from "react-cookie";
import FormComponent from "dataphi-react-components/dist/Containers/FormScreen/FormComponent";

import history from "./../../../history";
import LoginDefs from "./LoginDefs";
import Phi from "../../../Phi/Phi";

import HSGLogo from "../../../Assets/logo/hsgLogo.png";
import "./Login.css";

class Login extends Component {
  componentWillMount() {
    let isAuthenticated = Phi.User.isAuthenticated(); // Determines whether the token is set or not

    if (!!isAuthenticated) {
      this.getNewRedirection();
    }
  }

  componentWillReceiveProps(newProps) {
    let isAuthenticated = Phi.User.isAuthenticated();

    if (!!isAuthenticated) {
      this.getNewRedirection();
    }

    if (newProps.error && newProps.errorCode) {
      // Check for error and forbidden status code in case of incorrect login credentials
      const errorMap = {
        401: "Incorrect username or password",
        403: "Unauthorized user",
        500: "Something went wrong!",
      };

      alert(errorMap[newProps.errorCode] || "Something went wrong!");
      this.props.loginResponse({
        ok: false,
        error: false,
        errorCode: null,
        message: "Clear Login State",
      });
    }
  }

  getNewRedirection = () => {
    const jsonValue = userCustom ? userCustom.json_value : null;
    const userCustom = Phi.User.userCustomJson();

    history.push(
      jsonValue && !!!jsonValue.actionMap
        ? "/dashboard"
        : jsonValue.actionMap && jsonValue.actionMap.includes("dashboard")
          ? "/dashboard"
          : jsonValue.actionMap && jsonValue.actionMap.includes("smartClinic")
            ? "/smart-clinic"
            : jsonValue.actionMap && jsonValue.actionMap.includes("infirmary")
              ? "/infirmary"
              : "/",
    );
  };

  handleLogin(data) {
    let persistent = {
      selected: false,
      cookies: null,
    };
    if (Boolean(data.rememberMe) && data.rememberMe[0] === "yes") {
      persistent.selected = true;
      persistent.cookies = this.props.cookies;
    }

    this.props.loginUser(data, persistent);
  }

  render() {
    const userProfile = Phi.User.profile();
    const userCustom = Phi.User.userCustomJson();
    const jsonValue = userCustom ? userCustom.json_value : null;

    return this.props.isAuthenticated ? (
      <Redirect
        to={
          jsonValue && !!!jsonValue.actionMap
            ? "/dashboard"
            : jsonValue.actionMap && jsonValue.actionMap.includes("dashboard")
              ? "/dashboard"
              : jsonValue.actionMap &&
                  jsonValue.actionMap.includes("smartClinic")
                ? "/smart-clinic"
                : jsonValue.actionMap &&
                    jsonValue.actionMap.includes("infirmary")
                  ? "/infirmary"
                  : "/"
        }
      />
    ) : (
      <div className="hsg-login-container">
        <div className="container">
          <div className="row">
            <div className="hsg-login-logo-content">
              <a href="/">
                <img
                  style={{ height: 130, width: 260 }}
                  src={HSGLogo}
                  alt="hsg-logo"
                />
              </a>
            </div>
          </div>
          <div className="">
            <div className="hsg-login-content">
              <div className="hsg-card hsg-login-panel">
                <div className="hsg-login-header">Login to your account</div>
                <div className="">
                  <FormComponent
                    formDefs={LoginDefs}
                    onSubmit={(data) => this.handleLogin(data)}
                    onFieldBlur={(input) => {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(Login);
